/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 238:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(239);
/* harmony import */ var core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(201);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_15__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


















var customSelectHybrid = function customSelectHybrid(customSelectHybridsSelectors) {
  /* Features needed to make the selectCustom work for mouse users.
  - Toggle custom select visibility when clicking the "box"
  - Update custom select value when clicking in a option
  - Navigate through options when using keyboard up/down
  - Pressing Enter or Space selects the current hovered option
  - Close the select when clicking outside of it
  - Sync both selects values when selecting a option. (native or custom)
  */
  if (!customSelectHybridsSelectors && !customSelectHybridsSelectors.length > 0) return;
  customSelectHybridsSelectors.forEach(function (select) {
    var elSelectNative = select.querySelector('.js-selectNative');
    var elSelectCustom = select.querySelector('.js-selectCustom');
    var elSelectNative2 = select.querySelector('.js-selectNative2');
    var elSelectCustom2 = select.querySelector('.js-selectCustom2');
    var elSelectCustomBox = elSelectCustom.children[0];
    var elSelectCustomOpts = elSelectCustom.children[1];
    var elSelectCustomBox2 = elSelectCustom2.children[0];
    var elSelectCustomOpts2 = elSelectCustom2.children[1];
    var optionChecked = '';
    var optionHoveredIndex = -1; // Toggle custom select visibility when clicking the box

    elSelectCustomBox.addEventListener('click', function () {
      console.log("event");
      var isClosed = !elSelectCustom.classList.contains('isActive');

      if (isClosed) {
        openSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative, elSelectCustomBox);
        closeSelectCustom(elSelectCustomOpts2, elSelectCustom2, elSelectNative2);
      } else {
        closeSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative);
      }
    });
    elSelectCustomBox2.addEventListener('click', function () {
      var isClosed = !elSelectCustom2.classList.contains('isActive');

      if (isClosed) {
        openSelectCustom(elSelectCustomOpts2, elSelectCustom2, elSelectNative2, elSelectCustomBox2);
      } else {
        closeSelectCustom(elSelectCustomOpts2, elSelectCustom2, elSelectNative2);
      }
    });

    function openSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative, elSelectCustomBox) {
      var customOptsList = Array.from(elSelectCustomOpts.children);
      elSelectCustom.classList.add('isActive'); // Remove aria-hidden in case this was opened by a user
      // who uses AT (e.g. Screen Reader) and a mouse at the same time.

      elSelectCustom.setAttribute('aria-hidden', false);

      if (optionChecked) {
        var optionCheckedIndex = customOptsList.findIndex(function (el) {
          return el.getAttribute('data-value') === optionChecked;
        });
        updateCustomSelectHovered(optionCheckedIndex, elSelectCustomOpts);
      } // Add related event listeners


      document.addEventListener('click', function (e) {
        return watchClickOutside(e, elSelectCustomOpts, elSelectNative, elSelectCustom);
      });
      document.addEventListener('keydown', function (e) {
        return supportKeyboardNavigation(e, elSelectCustomOpts, elSelectNative, elSelectCustom, elSelectCustomBox);
      });
    }

    function closeSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative) {
      elSelectCustom.classList.remove('isActive');
      elSelectCustom.setAttribute('aria-hidden', true);
      updateCustomSelectHovered(-1, elSelectCustomOpts); // Remove related event listeners

      document.removeEventListener('click', function (e) {
        return watchClickOutside(e, elSelectCustomOpts, elSelectNative, elSelectCustom);
      });
      document.removeEventListener('keydown', function (e) {
        return supportKeyboardNavigation(e, elSelectCustomOpts, elSelectNative, elSelectCustom, elSelectCustomBox);
      });
    }

    function updateCustomSelectHovered(newIndex, elSelectCustomOpts) {
      var prevOption = elSelectCustomOpts === null || elSelectCustomOpts === void 0 ? void 0 : elSelectCustomOpts.children[optionHoveredIndex];
      var option = elSelectCustomOpts.children[newIndex];
      var options = elSelectCustomOpts.querySelectorAll(".selectCustom-option.isHover");
      options.forEach(function (option) {
        if (!option.classList.contains("isActive")) {
          option.classList.remove('isHover');
        }
      });

      if (prevOption) {
        prevOption.classList.remove('isHover');
      }

      if (option) {
        option.classList.add('isHover');
      }

      optionHoveredIndex = newIndex;
    }

    function updateCustomSelectChecked(value, text, elSelectCustomOpts, elSelectCustomBox) {
      var prevValue = optionChecked;
      var options = elSelectCustomOpts.querySelectorAll(".selectCustom-option");
      options.forEach(function (option) {
        if (option.classList.contains("isActive")) {
          option.classList.remove('isActive');
        }
      });
      var elPrevOption = elSelectCustomOpts.querySelector("[data-value=\"".concat(prevValue, "\""));
      var elOption = elSelectCustomOpts.querySelector("[data-value=\"".concat(value, "\""));

      if (elPrevOption) {
        elPrevOption.classList.remove('isActive');
      }

      if (elOption) {
        elOption.classList.add('isActive');
      }

      var newText = text.replace("In stock", "").replace("Out of stock", "");
      elSelectCustomBox.textContent = newText;
      optionChecked = value;
    }

    function watchClickOutside(evt, elSelectCustomOpts, elSelectNative, elSelectCustom) {
      var didClickedOutside = !elSelectCustom.contains(evt.target);

      if (didClickedOutside) {
        closeSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative);
      }
    }

    function supportKeyboardNavigation(evt, elSelectCustomOpts, elSelectNative, elSelectCustom, elSelectCustomBox) {
      var customOptsList = Array.from(elSelectCustomOpts.children);
      var optionsCount = customOptsList.length; // press down -> go next

      if (evt.keyCode === 40 && optionHoveredIndex < optionsCount - 1) {
        // prevent page scrolling
        evt.preventDefault();
        updateCustomSelectHovered(optionHoveredIndex + 1, elSelectCustomOpts);
      } // press up -> go previous


      if (evt.keyCode === 38 && optionHoveredIndex > 0) {
        // prevent page scrolling
        evt.preventDefault();
        updateCustomSelectHovered(optionHoveredIndex - 1, elSelectCustomOpts);
      } // press Enter or space -> select the option


      if (evt.keyCode === 13 || evt.keyCode === 32) {
        evt.preventDefault();
        var option = elSelectCustomOpts.children[optionHoveredIndex];
        var value = option && option.getAttribute('data-value');

        if (value) {
          elSelectNative.value = value;
          updateCustomSelectChecked(value, option.textContent, elSelectCustomOpts, elSelectCustomBox);
        }

        closeSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative);
      } // press ESC -> close selectCustom


      if (evt.keyCode === 27) {
        closeSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative);
      }
    } // Update selectCustom value when selectNative is changed.


    elSelectNative.addEventListener('change', function (evt) {
      var value = evt.target.value;
      var elRespectiveCustomOption = elSelectCustomOpts.querySelectorAll("[data-value=\"".concat(value, "\"]"))[0];
      updateCustomSelectChecked(value, elRespectiveCustomOption.textContent, elSelectCustomOpts, elSelectCustomBox);
    });
    elSelectNative2.addEventListener('change', function (evt) {
      var value = evt.target.value;
      var elRespectiveCustomOption = elSelectCustomOpts2.querySelectorAll("[data-value=\"".concat(value, "\"]"))[0];
      updateCustomSelectChecked(value, elRespectiveCustomOption.textContent, elSelectCustomOpts2, elSelectCustomBox2);
    }); // Update selectCustom value when an option is clicked or hovered

    elSelectCustomOpts.addEventListener('click', function (evt) {
      var option = evt.target.closest('.selectCustom-option');
      if (!option) return;
      var value = option.getAttribute('data-value'); // Sync native select to have the same value

      elSelectNative.value = value;
      elSelectNative.dispatchEvent(new Event('change'));
      updateCustomSelectChecked(value, option.textContent, elSelectCustomOpts, elSelectCustomBox);
      closeSelectCustom(elSelectCustomOpts, elSelectCustom, elSelectNative);
    });
    elSelectCustomOpts2.addEventListener('click', function (evt) {
      var option = evt.target.closest('.selectCustom-option');
      if (!option) return;
      var value = option.getAttribute('data-value'); // Sync native select to have the same value

      elSelectNative2.value = value;
      elSelectNative2.dispatchEvent(new Event('change'));
      updateCustomSelectChecked(value, option.textContent, elSelectCustomOpts2, elSelectCustomBox2);
      closeSelectCustom(elSelectCustomOpts2, elSelectCustom2, elSelectNative2);
    });
    elSelectCustomOpts.addEventListener('mouseover', function (evt) {
      var option = evt.target.closest('.selectCustom-option');
      if (!option) return;
      var value = option.getAttribute('data-value');

      var index = _toConsumableArray(elSelectCustomOpts.children).findIndex(function (el) {
        return el.dataset.value === value;
      });

      updateCustomSelectHovered(index);
    });
    elSelectCustomOpts2.addEventListener('mouseover', function (evt) {
      var option = evt.target.closest('.selectCustom-option');
      if (!option) return;
      var value = option.getAttribute('data-value');

      var index = _toConsumableArray(elSelectCustomOpts2.children).findIndex(function (el) {
        return el.dataset.value === value;
      });

      updateCustomSelectHovered(index, elSelectCustomOpts2);
    });
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (customSelectHybrid);

/***/ }),

/***/ 165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ModalDialog)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(166);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(167);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var focus_trap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(171);













function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Options object can accept:
 * @param dialogEl - Modal dialog node
 * @param modalId - required to be able to close
 * @param [options] - triggerEl, toggleEl, focusEl, timerReveal
 */

var ModalDialog = /*#__PURE__*/function () {
  function ModalDialog(dialogEl, options) {
    var _this = this;

    _classCallCheck(this, ModalDialog);

    if (!dialogEl) return;
    this.options = _typeof(options) === 'object' ? options : null;
    var _this$options = this.options,
        modalId = _this$options.modalId,
        triggerEl = _this$options.triggerEl,
        toggleEl = _this$options.toggleEl,
        focusEl = _this$options.focusEl,
        timerReveal = _this$options.timerReveal;
    var nextPopup = localStorage.getItem("timerPopup-".concat(modalId));
    if (!modalId) throw new Error('Missing modalId');
    var modalCloseBtns = dialogEl.querySelectorAll("[data-modal-close=\"modal--".concat(modalId, "\"]"));
    this.modalIsOpen = false;
    var focusTrap = (0,focus_trap__WEBPACK_IMPORTED_MODULE_12__.createFocusTrap)(dialogEl, {
      initialFocus: focusEl,
      allowOutsideClick: true
    });

    this.showModal = function () {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      dialogEl.hidden = false;
      dialogEl.setAttribute('aria-modal', true);
      dialogEl.classList.add('modal--visible');
      document.documentElement.classList.add('modal-js--open');
      document.documentElement.classList.add("".concat(modalId, "-modal-js--open"));

      if (!settings.disableFocusTrap) {
        setTimeout(function () {
          focusTrap.activate();
        }, 500);
      }

      _this.modalIsOpen = true;
      toggleEl === null || toggleEl === void 0 ? void 0 : toggleEl.forEach(function (button) {
        return button.classList.add('is-active');
      });
      triggerEl === null || triggerEl === void 0 ? void 0 : triggerEl.forEach(function (button) {
        return button.classList.add('is-active');
      });
    };

    this.closeModal = function () {
      dialogEl.hidden = true;
      dialogEl.removeAttribute('aria-modal');
      dialogEl.classList.remove('modal--visible');
      focusTrap.deactivate();
      _this.modalIsOpen = false;
      toggleEl === null || toggleEl === void 0 ? void 0 : toggleEl.forEach(function (button) {
        return button.classList.remove('is-active');
      });
      triggerEl === null || triggerEl === void 0 ? void 0 : triggerEl.forEach(function (button) {
        return button.classList.remove('is-active');
      });
      document.documentElement.classList.remove("".concat(modalId, "-modal-js--open"));

      if (!document.querySelector('.modal--visible')) {
        document.documentElement.classList.remove('modal-js--open');
      }

      window.dispatchEvent(new Event("".concat(modalId, "-modal-closed")));
    };

    this.toggleModal = function () {
      if (_this.modalIsOpen) {
        _this.closeModal();
      } else {
        _this.showModal();
      }
    };

    dialogEl.addEventListener('click', function (evt) {
      if (evt.target.closest('.modal__dialog')) return;

      _this.closeModal();
    });
    document.documentElement.addEventListener('click', function (evt) {
      if (evt.target.closest('.modal__dialog') || !_this.modalIsOpen) return;
      evt.preventDefault();
      evt.stopPropagation();

      _this.closeModal();
    }, {
      capture: true
    });
    window.addEventListener('closeModal', function () {
      _this.closeModal();
    });
    window.addEventListener("".concat(modalId, "-open-modal"), function () {
      _this.showModal();
    });
    window.addEventListener("".concat(modalId, "-close-modal"), function () {
      _this.closeModal();
    });
    toggleEl === null || toggleEl === void 0 ? void 0 : toggleEl.forEach(function (button) {
      button.addEventListener('click', function (evt) {
        evt.preventDefault();

        _this.toggleModal();
      });
    });
    triggerEl === null || triggerEl === void 0 ? void 0 : triggerEl.forEach(function (button) {
      button.addEventListener('click', function (evt) {
        evt.preventDefault();

        _this.showModal();
      });
    });

    if (timerReveal && window.localStorage && this.options.trigger !== 'exit-intent') {
      var now = new Date();
      now = now.setHours(now.getHours());

      if (!nextPopup || nextPopup <= now) {
        window.setTimeout(function () {
          _this.showModal();
        }, timerReveal);
      }
    }

    modalCloseBtns === null || modalCloseBtns === void 0 ? void 0 : modalCloseBtns.forEach(function (button) {
      button.addEventListener('click', function (evt) {
        evt.preventDefault();

        _this.closeModal();

        if (timerReveal && window.localStorage && modalId) {
          if (nextPopup > new Date()) {
            return;
          }

          _this.setLocalStorage();
        }
      });
    });
  }

  _createClass(ModalDialog, [{
    key: "setLocalStorage",
    value: function setLocalStorage() {
      var date = new Date();
      var frequency = this.options.trigger === 'exit-intent' ? this.options.frequencyDelay : 24;
      var expires = date.setHours(date.getHours() + frequency);
      localStorage.setItem("timerPopup-".concat(this.options.modalId), expires);
    }
  }]);

  return ModalDialog;
}();



/***/ }),

/***/ 184:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PRODUCT_CARD_SLIDER_SELECTOR": () => (/* binding */ PRODUCT_CARD_SLIDER_SELECTOR),
/* harmony export */   "PRODUCT_CARD_SELECTOR": () => (/* binding */ PRODUCT_CARD_SELECTOR),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(104);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(110);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(149);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(185);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(166);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(186);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(188);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(189);
/* harmony import */ var core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_set_prototype_of_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(190);
/* harmony import */ var core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_prototype_of_js__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(167);
/* harmony import */ var core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_string_js__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(191);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(192);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(194);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(195);
/* harmony import */ var core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_map_js__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var core_js_modules_es_object_create_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(200);
/* harmony import */ var core_js_modules_es_object_create_js__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_create_js__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(201);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_33__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _wishlist__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(235);
/* harmony import */ var _product_sizes_modal__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(236);
/* harmony import */ var _wishlist_modal__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(237);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }










































var PRODUCT_CARD_SLIDER_SELECTOR = ".product-card__slider";

function ProductCard(container, isReload) {
  var _container$querySelec, _container$querySelec2, _wishlistSizesSelect$, _container$querySelec3, _window, _window$theme, _window$theme$breakpo;

  if (!container) return;
  if (container.classList.contains("is-loaded") && !isReload) return;
  container.classList.add("is-loaded"); // console.log("here container", container);

  var swatches = container.querySelectorAll(".swatch__item");
  var sliderEl = container.querySelector(PRODUCT_CARD_SLIDER_SELECTOR);
  var previousButton = container.querySelector(".btn--control-prev");
  var nextButton = container.querySelector(".btn--control-next");
  var sizesElement = container.querySelector(".product-card__form");
  var wishlistSizesSelect = container.querySelector("[data-wishlist-size-selector]");
  var wishlistSizesSelectCustom = container.querySelector("[data-wishlist-size-selector-custom]");
  var wishlistBtn = container.querySelector("[data-trigger-wishlist-modal]");
  var productColour = ((_container$querySelec = container.querySelector(".swatch__item--selected")) === null || _container$querySelec === void 0 ? void 0 : (_container$querySelec2 = _container$querySelec.dataset) === null || _container$querySelec2 === void 0 ? void 0 : _container$querySelec2.colour) || null;
  var isWishlistPage = Boolean(container.closest(".wishlist-container"));
  var selectedVariantId = wishlistSizesSelect === null || wishlistSizesSelect === void 0 ? void 0 : (_wishlistSizesSelect$ = wishlistSizesSelect.options[wishlistSizesSelect.selectedIndex]) === null || _wishlistSizesSelect$ === void 0 ? void 0 : _wishlistSizesSelect$.value;
  var comparePrice = Number(container.dataset.comparePrice);
  var productCardId = container.dataset.productId;
  var productHandle = container === null || container === void 0 ? void 0 : (_container$querySelec3 = container.querySelector(".product-card__title a")) === null || _container$querySelec3 === void 0 ? void 0 : _container$querySelec3.href; // swatches new logic 

  var ColourSwatchesCard = /*#__PURE__*/function (_HTMLElement) {
    _inherits(ColourSwatchesCard, _HTMLElement);

    var _super = _createSuper(ColourSwatchesCard);

    function ColourSwatchesCard() {
      _classCallCheck(this, ColourSwatchesCard);

      return _super.call(this);
    }

    _createClass(ColourSwatchesCard, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this = this;

        this.settings = this.setSettings();
        if (!this.settings) return;
        this.container = this.querySelector('.colour-swatches__container');
        this.container_colors = this.querySelector('.product-stitched__swatches');
        this.initPopStateListener();
        this.preloadedSections = {};
        var hideIfEmpty = this.settings.hideIfEmpty;

        if (this.settings.groupTag) {
          fetch("/collections/all/".concat(encodeURIComponent(this.settings.groupTag), "?view=data")).then(function (response) {
            return response.json();
          }).then(function (responseJson) {
            var fashionProducts = responseJson.filter(function (product) {
              return product.tags.includes(_this.settings.group_tag_limited_styles);
            });
            var colorGroupProducts = responseJson;

            _this.initSwatches(colorGroupProducts, 'colour');

            _this.attachColorSwatchEventListeners();

            _this.hideIfEmpty(hideIfEmpty);
          });
        } else {
          this.hideIfEmpty(hideIfEmpty);
        }
      }
    }, {
      key: "initPopStateListener",
      value: function initPopStateListener() {
        var _this2 = this;

        window.addEventListener('popstate', function (event) {
          return _this2.handlePopState(event);
        });
      }
    }, {
      key: "handlePopState",
      value: function handlePopState(event) {
        if (event.state && event.state.path) {
          var url = event.state.path;
          this.updateSection(url.replaceAll('/products/', ''));
        }
      }
    }, {
      key: "hideIfEmpty",
      value: function hideIfEmpty(_hideIfEmpty) {
        if (!_hideIfEmpty) return;
        var swatches = this.querySelectorAll('.colour-swatches__container input');
        var swatches_colors = this.querySelectorAll('.pdp-colour-swatch__color-list li');
        if (swatches.length > 0 || swatches_colors.length > 0) return;
        this.classList.add("swatch-empty--hide");
      }
    }, {
      key: "setSettings",
      value: function setSettings() {
        var settingsRawJson = this.querySelector("[data-settings]");
        if (!settingsRawJson) return {};
        return JSON.parse(settingsRawJson.innerHTML);
      }
    }, {
      key: "initSwatches",
      value: function initSwatches(products, type) {
        var _this3 = this;

        var html = "";
        var html_colors = "";
        var self = this;
        products.forEach(function (product) {
          var handleize = function handleize(str) {
            return str.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
          };

          var option1 = product.selected_or_first_available_variant.option1;
          var handleizedOption1 = handleize(option1);

          if (_this3.settings.hiddeOptionsOutOfStock) {
            if (product.available && product.template == null) {
              var imgSrc = _this3.getProductImageSrc(product);

              var li_element = "<li class=\"swatch__list-item new_logic\">\n                                <a data-aria-label=\"".concat(product.color_group, "\" data-product=\"").concat(product.handle, "\" data-colour=\"").concat(product.color_group, "\" class=\"swatch__item swatch--").concat(product.color_group, "  \" href=\"/products/").concat(product.handle, "\" data-href=\"/products/").concat(product.handle, "\">\n                                    <span class=\"visually-hidden\">Black</span>\n                                </a>\n                                </li>");
              html_colors += li_element;
            }
          } else {
            var _imgSrc = _this3.getProductImageSrc(product);

            var _li_element = "<li class=\"swatch__list-item new_logic\">\n                                <a data-aria-label=\"".concat(product.color_group, "\" data-product=\"").concat(product.handle, "\" data-colour=\"").concat(product.color_group, "\" class=\"swatch__item swatch--").concat(product.color_group, "  \" href=\"/products/").concat(product.handle, "\" data-href=\"/products/").concat(product.handle, "\">\n                                    <span class=\"visually-hidden\">Black</span>\n                                </a>\n                                </li>");

            html_colors += _li_element;
          }
        });

        if (html || html_colors) {
          if (type == 'colour') {
            if (this.container) this.container.innerHTML = html;
            if (this.container_colors) this.container_colors.innerHTML = html_colors;
          }

          this.markCurrentSwatch();
        }
      }
    }, {
      key: "getProductImageSrc",
      value: function getProductImageSrc(product) {
        var _this4 = this;

        var imageSrc = product.featured_image;

        switch (this.settings.image_type) {
          case "color_swatch":
            var colourTag = product.tags.find(function (tag) {
              return tag.indexOf(_this4.settings.colourTagPrefix) > -1;
            });

            if (colourTag) {
              var colour = colourTag.replace(this.settings.colourTagPrefix, "").toLowerCase();
              imageSrc = colour;
            }

          default:
            break;
        }

        return imageSrc;
      }
    }, {
      key: "getProductImage",
      value: function getProductImage(product) {
        var imageSrc = this.getProductImageSrc(product);
        var image = "<img src=\"".concat(imageSrc, "\">");
        return image;
      }
    }, {
      key: "updateSection",
      value: function updateSection(url) {
        // Reattach event listeners after the update
        this.attachColorSwatchEventListeners();
      }
    }, {
      key: "getProductPath",
      value: function getProductPath(url) {
        var urlParts = url.split('?'); // Split the URL at the query string

        return urlParts[0]; // Return the part before the query string
      }
    }, {
      key: "markCurrentSwatch",
      value: function markCurrentSwatch() {
        var _this$settings, _this$container_color, _this$container;

        var handle = (_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : _this$settings.product_handle;
        if (!handle) return;
        var current = ((_this$container_color = this.container_colors) === null || _this$container_color === void 0 ? void 0 : _this$container_color.querySelector("[data-product=\"".concat(handle, "\"]"))) || ((_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.querySelector("[data-handle=\"".concat(handle, "\"]")));
        current === null || current === void 0 ? void 0 : current.classList.add("swatch__item--selected");
      }
    }, {
      key: "attachColorSwatchEventListeners",
      value: function attachColorSwatchEventListeners() {
        var swatches = this.container_colors;
        if (!swatches) return;
        swatches.classList.add("is-compact", "custom-swatches");
        var swatchesCount = swatches.querySelectorAll(".swatch__item").length;

        if (swatchesCount > 5 && !swatches.querySelector(".swatch__truncate")) {
          var truncateSwatche = document.createElement("li");
          truncateSwatche.classList.add("swatch__truncate", "medium-down--hide", "large-up--show");
          truncateSwatche.innerHTML = "<a href=\"".concat(productHandle || "#", "\"><svg aria-label=\"Plus icon\" class=\"icon icon-plus\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlnsHref=\"http://www.w3.org/2000/svg\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.2\" vector-effect=\"non-scaling-stroke\" d=\"M12 6v12M6 12h12\"></path></svg>").concat(swatchesCount - 5, "</a>");
          swatches.append(truncateSwatche);
        }

        var cardContainer = swatches.closest(".product-card");
        if (!cardContainer) return;
        swatches.querySelectorAll(".swatch__item").forEach(function (item) {
          if (item.dataset.listenerAttached) return;
          item.dataset.listenerAttached = "true";
          item.addEventListener("click", function (event) {
            event.preventDefault();
            if (item.matches(".swatch__item--selected")) return;
            var swatchHandle = item.dataset.product;
            replaceProduct(event, swatchHandle, cardContainer);
          });
        });
      }
    }]);

    return ColourSwatchesCard;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  if (!customElements.get("colour-swatches-card")) {
    customElements.define("colour-swatches-card", ColourSwatchesCard);
  } //console.log("here productHandle", productHandle); 
  // render old swatches
  // if (!window.theme.render_new_swatches) {
  // if(productHandle) {
  //   try {
  //     fetch(productHandle)
  //       .then((response) => response.text())
  //       .then((data) => {
  //         const div = document.createElement("div");
  //         div.innerHTML = data;
  //         const swatches = div.querySelector(".product-stitched__swatches");
  //         if(swatches){
  //           swatches.classList.add("is-compact");
  //           swatches.classList.add("custom-swatches");
  //           const swatchesCount = swatches.querySelectorAll(".swatch__item").length;
  //           if(swatchesCount > 5) {
  //             const truncateSwatche = document.createElement("li");
  //             truncateSwatche.classList.add("swatch__truncate");
  //             truncateSwatche.classList.add("medium-down--hide");
  //             truncateSwatche.classList.add("large-up--show");
  //             truncateSwatche.innerHTML = `<a href="${productHandle}"><svg aria-label="Plus icon" class="icon icon-plus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlnsHref="http://www.w3.org/2000/svg"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" vector-effect="non-scaling-stroke" d="M12 6v12M6 12h12"></path></svg>${swatchesCount - 5}</a>`;
  //             swatches.append(truncateSwatche)
  //           }
  //         }
  //         const productCardSwatches = container.querySelector(".product-card__stitching-wishlist");
  //         if (swatches && productCardSwatches) {
  //           productCardSwatches.innerHTML = swatches.outerHTML;
  //           productCardSwatches.querySelectorAll(".swatch__item").forEach((item) => {
  //             item.addEventListener("click", (event) => {
  //               event.preventDefault();
  //               if (item.matches(".swatch__item--selected")) return;
  //               const swatchHandle = item.dataset.product;
  //               console.log("here clicking", swatchHandle);
  //               replaceProduct(event, swatchHandle, container);
  //             })
  //           })
  //         }
  //       });
  //   } catch(err) {
  //     console.error("Error rebuilding swatches", err);
  //   }
  // }
  // }
  //console.log("here window.theme.collection_page", window.theme.collection_page);

  /**
   * Function to wait for swatches to be rendered by SearchSpring
   * and attach event listeners once they're available
   */


  function attachCollectionPageSwatchListeners(container) {
    var swatches_collection_page = container.querySelectorAll(".swatch__item"); // If swatches already exist, attach listeners immediately

    if (swatches_collection_page.length > 0) {
      //console.log("here swatches collection page", swatches_collection_page);
      swatches_collection_page.forEach(function (swatch) {
        // Check if listener already attached to avoid duplicates
        if (!swatch.dataset.listenerAttached) {
          swatch.dataset.listenerAttached = "true";
          swatch.addEventListener("click", function (event) {
            event.preventDefault();
            var swatchHandle = swatch.dataset.product;
            replaceProduct(event, swatchHandle, container);
          });
        }
      });
      return true; // Swatches found and listeners attached
    }

    return false; // Swatches not found yet
  }

  if (window.theme.collection_page) {
    // Try to attach listeners immediately
    var swatchesFound = attachCollectionPageSwatchListeners(container); // If swatches weren't found, set up MutationObserver to watch for them

    if (!swatchesFound) {
      var observer = new MutationObserver(function (mutations, obs) {
        var swatchesFound = attachCollectionPageSwatchListeners(container);

        if (swatchesFound) {
          // Swatches found, disconnect observer
          obs.disconnect();
        }
      }); // Start observing the container for child changes

      observer.observe(container, {
        childList: true,
        subtree: true
      }); // Also set a timeout as a fallback (disconnect after 10 seconds)

      setTimeout(function () {
        observer.disconnect();
      }, 5000);
    }
  }

  swatches === null || swatches === void 0 ? void 0 : swatches.forEach(function (swatch) {
    if (window.theme.hideSwatches) {
      var _window$theme$locale;

      var rootUrl = (_window$theme$locale = window.theme.locale) !== null && _window$theme$locale !== void 0 && _window$theme$locale.primary ? "" : window.theme.locale.rootUrl;
      var url = "".concat(rootUrl, "/products/").concat(swatch.dataset.product, ".js");
      console.log("here url", url);

      try {
        fetch(url).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (data.available === false) {
            var _swatch$closest;

            (_swatch$closest = swatch.closest(".swatch__list-item")) === null || _swatch$closest === void 0 ? void 0 : _swatch$closest.remove();
          }
        });
      } catch (error) {
        var _swatch$closest2;

        (_swatch$closest2 = swatch.closest(".swatch__list-item")) === null || _swatch$closest2 === void 0 ? void 0 : _swatch$closest2.remove();
        console.error("Error fetching product data", error);
      }
    }

    swatch.addEventListener("click", function (event) {
      event.preventDefault();
      if (swatch.matches(".swatch__item--selected")) return;
      var swatchHandle = swatch.dataset.product;
      replaceProduct(event, swatchHandle, container);
    });
  }); // Handles Wishlist UI

  if (wishlistBtn) {
    // set initial wishlist UI state
    applyButtonWishlistState(wishlistBtn, productCardId); // re-update wishlist state whenever wishlisting items fetched.

    document.addEventListener("wishlistItemsFetched", function () {
      return applyButtonWishlistState(wishlistBtn, productCardId);
    });
    var _wishlistBtn$dataset = wishlistBtn.dataset,
        _productHandle = _wishlistBtn$dataset.productHandle,
        productId = _wishlistBtn$dataset.productId,
        productPrice = _wishlistBtn$dataset.productPrice,
        productTitle = _wishlistBtn$dataset.productTitle;
    var wishlistProduct = {
      epi: null,
      du: "".concat(window.location.origin, "/products/").concat(_productHandle),
      empi: productId,
      pr: productPrice
    };

    if (isWishlistPage) {
      var gridWrapper = document.querySelector(".wishlist-container");
      var currentVariant = wishlistBtn.dataset.selectedVariantId;
      var parentElement = wishlistBtn.closest(".wishlist__item");
      var addToCartBtn = wishlistBtn.closest(".wishlist__item").querySelector(".wishlist__addToCart");
      wishlistProduct.epi = currentVariant;
      var comparePriceWishlist = Number(parentElement.querySelector(".product-card").dataset.comparePrice);
      var productTagsDiv = evt.target.querySelector("button[data-product-tags]");
      var productTags = productTagsDiv ? productTagsDiv.getAttribute("data-product-tags") : null;
      wishlistBtn.addEventListener("click", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,_wishlist__WEBPACK_IMPORTED_MODULE_39__.removeFromWishList)(wishlistProduct);

              case 2:
                response = _context.sent;

                if (!(response.ok === false)) {
                  _context.next = 5;
                  break;
                }

                throw new Error("Could not remove item from wishlist");

              case 5:
                parentElement.remove();
                gridWrapper.dataset.itemCount = Number(gridWrapper.dataset.itemCount) - 1;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
      addToCartBtn.addEventListener("click", /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
          var properties, formdata, clickAndCollect, item;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  properties = {};
                  formdata = new FormData(e.target);
                  clickAndCollect = formdata.get("properties[click_collect]");
                  Object.assign(properties, {
                    _compare_price: comparePriceWishlist
                  });
                  clickAndCollect && Object.assign(properties, {
                    _click_and_collect: clickAndCollect
                  });

                  if (productTags && productTags.includes("DONOTSHIP")) {
                    properties["_do_not_ship"] = "DONOTSHIP";
                  }

                  item = {
                    id: wishlistProduct.epi,
                    quantity: 1,
                    properties: properties
                  };
                  _context3.next = 9;
                  return window.sideCart.handleAddToCartEvent(item, true, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var removeResponse;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return (0,_wishlist__WEBPACK_IMPORTED_MODULE_39__.removeFromWishList)(wishlistProduct);

                          case 2:
                            removeResponse = _context2.sent;

                            if (!(removeResponse.ok === false)) {
                              _context2.next = 5;
                              break;
                            }

                            throw new Error("Could not remove item from wishlist");

                          case 5:
                            addToCartBtn.closest(".wishlist__item").remove();

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })));

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    } else {
      (0,_wishlist_modal__WEBPACK_IMPORTED_MODULE_41__.createWishlistModalUI)("#modal--wishlist");
      wishlistBtn.addEventListener("click", function () {
        (0,_wishlist_modal__WEBPACK_IMPORTED_MODULE_41__.openWishlistModal)(_productHandle, wishlistSizesSelect, wishlistSizesSelectCustom, productTitle, productColour, wishlistProduct);
      });
    }
  }

  var mediaQueryList = window.matchMedia("(min-width: ".concat(((_window = window) === null || _window === void 0 ? void 0 : (_window$theme = _window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$breakpo = _window$theme.breakpoints) === null || _window$theme$breakpo === void 0 ? void 0 : _window$theme$breakpo.large) || 990, "px)"));

  if (sliderEl) {
    var initialSliderIndex = 0;

    if (mediaQueryList.matches) {
      initialSliderIndex = 1;
    }

    var slider = new (flickity__WEBPACK_IMPORTED_MODULE_37___default())(sliderEl, {
      cellSelector: ".product-card__slide",
      draggable: true,
      prevNextButtons: false,
      pageDots: true,
      adaptiveHeight: true,
      watchCSS: true,
      wrapAround: true,
      initialIndex: initialSliderIndex
    });

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", function (mq) {
        if (!mq.matches) {
          slider.select(0);
        }
      });
    } // Reset slider to 2nd image on desktop after mouse left & primary image is shown


    sliderEl.addEventListener("mouseleave", function () {
      if (slider.selectedIndex !== 0) return;
      var sliderWrapper = sliderEl.closest(".product-card__image--secondary");
      sliderWrapper.addEventListener("transitionend", function () {
        slider.select(1, true, true);
      });
    });
    previousButton === null || previousButton === void 0 ? void 0 : previousButton.addEventListener("click", function () {
      return slider.previous();
    });
    nextButton === null || nextButton === void 0 ? void 0 : nextButton.addEventListener("click", function () {
      return slider.next();
    }); // re-render flickity when collection layout is switched

    window.addEventListener("collection:layoutChange", function () {
      setTimeout(function () {
        slider.resize();
      }, 500);
    });
  } // Handles Product Sizes modal (for mobile)


  (0,_product_sizes_modal__WEBPACK_IMPORTED_MODULE_40__.createSizeModalUI)("#modal--product-sizes");
  var toggleProductSizesModal = container.querySelector("[data-open-product-sizes]");

  if (toggleProductSizesModal) {
    var _productHandle2 = toggleProductSizesModal.dataset.productHandle;
    toggleProductSizesModal.addEventListener("click", function () {
      (0,_product_sizes_modal__WEBPACK_IMPORTED_MODULE_40__.openProductModal)(_productHandle2, sizesElement);
    });
  } // Handles Add to Cart by clicking Size Variant


  if (sizesElement) {
    sizesElement.addEventListener("click", function (evt) {
      var target = evt.target;

      if (wishlistSizesSelect) {
        if (target.matches(".product-card__variant")) {
          evt.preventDefault();
          var url = window.location.href;
          var formElements = target.closest('[action="/cart/add"]');

          var propertiesInputs = _toConsumableArray(formElements === null || formElements === void 0 ? void 0 : formElements.querySelectorAll('[name^="properties"]'));

          var parent_div = formElements.parentElement.parentElement.parentElement;
          var data_layer_data = parent_div.dataset; //console.log("here parent div", data_layer_data)

          var properties = {};
          propertiesInputs.forEach(function (node) {
            properties[node.name.replace('properties[', '').replace(']', '')] = node.value;
          });
          selectedVariantId = Number(evt.target.dataset.variantId);
          comparePrice = Number(evt.target.dataset.variantComparePrice);

          var _productTagsDiv = evt.target.querySelector("button[data-product-tags]");

          var _productTags = _productTagsDiv ? _productTagsDiv.getAttribute("data-product-tags") : null;

          if (url.indexOf("/cart") !== -1) {
            var productname = data_layer_data.productHandle.replace(/-/g, ' ');
            var _productHandle3 = data_layer_data.productHandle;

            var category = _productHandle3.split('-').pop(); //console.log("adding datalayer", evt.target.innerHTML);


            dataLayer.push({
              event: "ee_addToCart",
              product_name: productname,
              product_handle: data_layer_data.productHandle,
              product_id: data_layer_data.productId,
              product_price: data_layer_data.productPrice,
              currency: Shopify.currency.active,
              product_brand: data_layer_data.productBrand,
              product_type: data_layer_data.productType,
              category_title: "Cart",
              // Could be "The Blue Edit - Mini Cart"
              category_handle: category,
              quantity: 1,
              variant_id: selectedVariantId,
              variant_title: evt.target.innerHTML,
              product_sku: data_layer_data.productSku,
              g_product_id: "shopify_" + Shopify.country + "_" + data_layer_data.productId + "_" + selectedVariantId
            });
          }

          Object.assign(properties, {
            _compare_price: comparePrice
          });

          if (_productTags && _productTags.includes("DONOTSHIP")) {
            properties["_do_not_ship"] = "DONOTSHIP";
          }

          var item = {
            id: selectedVariantId,
            quantity: 1,
            properties: properties
          };
          window.sideCart.handleAddToCartEvent(item, true);
        }
      }
    });
  }
  /**
   * Function that updates product card with new fetched product
   */


  function replaceProduct(_x2, _x3, _x4) {
    return _replaceProduct.apply(this, arguments);
  }

  function _replaceProduct() {
    _replaceProduct = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(event, handle, container) {
      var _window$theme$locale2;

      var rootUrl, url, response, _originalSwatches$que, _event$target$closest, contentFetched, parser, containerFetched, productCardFetched, originalSwatches, originalSwatchesContent, newSwatches;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!container || !handle)) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              rootUrl = (_window$theme$locale2 = window.theme.locale) !== null && _window$theme$locale2 !== void 0 && _window$theme$locale2.primary ? "" : window.theme.locale.rootUrl;
              url = "".concat(rootUrl, "/products/").concat(handle, "?view=card");
              _context4.next = 6;
              return fetch(url);

            case 6:
              response = _context4.sent;

              if (!response.ok) {
                _context4.next = 30;
                break;
              }

              _context4.next = 10;
              return response.text();

            case 10:
              contentFetched = _context4.sent;
              parser = new DOMParser();
              containerFetched = parser.parseFromString(contentFetched, "text/html");
              productCardFetched = containerFetched.querySelector(".product-card");

              if (productCardFetched) {
                _context4.next = 16;
                break;
              }

              return _context4.abrupt("return");

            case 16:
              originalSwatches = container.querySelector(".product-stitched__swatches");

              if (originalSwatches) {
                _context4.next = 19;
                break;
              }

              return _context4.abrupt("return");

            case 19:
              (_originalSwatches$que = originalSwatches.querySelector(".swatch__item--selected")) === null || _originalSwatches$que === void 0 ? void 0 : _originalSwatches$que.classList.remove("swatch__item--selected");
              (_event$target$closest = event.target.closest(".swatch__item")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.classList.add("swatch__item--selected");
              originalSwatchesContent = originalSwatches.innerHTML; // Swap out most of the product card contents (except swatches)

              container.innerHTML = productCardFetched.innerHTML;
              newSwatches = container.querySelector(".product-stitched__swatches");
              if (newSwatches) newSwatches.innerHTML = originalSwatchesContent; // update the product card outer element

              container.dataset.selectedVariantId = productCardFetched.dataset.selectedVariantId;
              container.dataset.productId = productCardFetched.dataset.productId;
              container.dataset.productHandle = productCardFetched.dataset.productHandle;
              container.dataset.productPrice = productCardFetched.dataset.productPrice; // rehydrate the new DOM

              ProductCard(container, true);

            case 30:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _replaceProduct.apply(this, arguments);
  }
}
/**
 * @function applyButtonWishlistState - compares the wishlistItems according to
 * swym and update the present product cards wishlisting state based on whether
 * it is in the wishlisted items.
 *
 * @param {Element}       wishlistBtn
 * @param {string|number} productCardId
 *
 * @returns void
 */


function applyButtonWishlistState(wishlistBtn, productCardId) {
  var _window$wishlistItems;

  var isWishlisted = (_window$wishlistItems = window.wishlistItems) === null || _window$wishlistItems === void 0 ? void 0 : _window$wishlistItems.some(function (item) {
    return Number(item.empi) === Number(productCardId);
  });

  if (isWishlisted) {
    wishlistBtn.classList.add("icon-animate");
  } else {
    wishlistBtn.classList.remove("icon-animate");
  }
}

var PRODUCT_CARD_SELECTOR = ".product-card";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductCard);

/***/ }),

/***/ 275:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hydrateProductCardsSliders": () => (/* binding */ hydrateProductCardsSliders),
/* harmony export */   "hydrateProductsWithinElement": () => (/* binding */ hydrateProductsWithinElement),
/* harmony export */   "resizeSliderOnTabChange": () => (/* binding */ resizeSliderOnTabChange)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(144);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(145);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(276);
/* harmony import */ var _product_card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(184);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














/**
 * hydrateProductCardsSliders adds the slider behaviour to the raw slider HTML
 * and the raw products within that.
 *
 * @param {NodeList|array} sliders                - Slider nodes to hydrate
 * @param {object}         options                - options object
 */

var hydrateProductCardsSliders = function hydrateProductCardsSliders(sliders, options) {
  if (sliders.length === 0) {
    return;
  }

  var isDesktop = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.large, "px)")).matches;
  sliders.forEach(function (slider) {
    var _slider$querySelector;

    var cardCount = (_slider$querySelector = slider.querySelectorAll(_product_card__WEBPACK_IMPORTED_MODULE_12__.PRODUCT_CARD_SELECTOR)) === null || _slider$querySelector === void 0 ? void 0 : _slider$querySelector.length;
    if (!cardCount) return;

    if (isDesktop && cardCount < 5) {
      slider.classList.add('product-cards-carousel__slider--sub-five');
    }

    hydrateMainSlider(slider, _objectSpread(_objectSpread({}, options), {}, {
      isDesktop: isDesktop
    }));
    hydrateProductsWithinElement(slider);
  });
};
/**
 * hydrateProductsWithinElement
 * @param {Element} element - element for which to hydrate descendant product cards
 */


var hydrateProductsWithinElement = function hydrateProductsWithinElement(element) {
  return element.querySelectorAll(_product_card__WEBPACK_IMPORTED_MODULE_12__.PRODUCT_CARD_SELECTOR).forEach(_product_card__WEBPACK_IMPORTED_MODULE_12__.default);
};
/**
 * hydrateMainSlider adds the slider behaviour to the raw slider HTML
 * and the raw products within that.
 *
 * @param {Element}  slider                 - Slider to hydrate
 * @param {object}   options                - options object
 * @param {boolean}  options.productCount   - how many products are contained in this slider?
 */


var hydrateMainSlider = function hydrateMainSlider(slider, _ref) {
  var isDesktop = _ref.isDesktop;
  return new (flickity__WEBPACK_IMPORTED_MODULE_9___default())(slider, {
    // options
    prevNextButtons: true,
    pageDots: isDesktop,
    imagesLoaded: true,
    setGallerySize: true,
    cellAlign: isDesktop ? 'center' : 'left',
    groupCells: isDesktop ? 3 : false,
    watchCSS: true,
    wrapAround: isDesktop,
    contain: !isDesktop
  });
};
/**
 * resizeSliderOnTabChange - finds tabs within the provided container and
 * sliders from the provided query and a listener to resize the sliders when
 * the tab changes.
 *
 * @param {Element}         container             - the container in which to find van11y tabs
 * @param {string|Element}  sliderSelectorOrNode  - selector to find the slider, or the slider node
 */


var resizeSliderOnTabChange = function resizeSliderOnTabChange(container, sliderSelectorOrNode) {
  container.querySelectorAll('.js-tablist__link').forEach(function (link) {
    link.addEventListener('click', function () {
      var tabID = link.getAttribute(_constants__WEBPACK_IMPORTED_MODULE_11__.VAN11Y_TAB_ID_ATTRIBUTE);
      var tab = document.querySelector("#".concat(tabID)); // Resize and update main flickity slider

      var slider = typeof sliderSelectorOrNode === 'string' ? tab.querySelector(sliderSelectorOrNode) : sliderSelectorOrNode;
      if (slider === null) return;
      var flickity = flickity__WEBPACK_IMPORTED_MODULE_9___default().data(slider);
      flickity.resize(); // Resize and update product flickity sliders

      slider.querySelectorAll(_product_card__WEBPACK_IMPORTED_MODULE_12__.PRODUCT_CARD_SLIDER_SELECTOR).forEach(function (cardSlider) {
        var flick = flickity__WEBPACK_IMPORTED_MODULE_9___default().data(cardSlider);
        flick.resize();
      });
    });
  });
};



/***/ }),

/***/ 247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initProductModal),
/* harmony export */   "openProductModal": () => (/* binding */ openProductModal)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _modal_dialog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(165);




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



function initProductModal() {
  var quickshopModalEl = document.querySelector('#modal--quickshop');
  var quickshopModalTrigger = document.querySelectorAll('[data-open-quick-shop]');

  if (quickshopModalEl && quickshopModalTrigger.length > 0) {
    var quickshopModal = new _modal_dialog__WEBPACK_IMPORTED_MODULE_4__.default(quickshopModalEl, {
      triggerEl: quickshopModalTrigger,
      modalId: 'quickshop'
    });
    window.quickshopModal = quickshopModal;
  }
}

function initProductModalContent() {
  var productModal = window.quickshopModal;

  if (!productModal) {
    return;
  }

  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__.load)('product-modal');
}

function openProductModal(_x) {
  return _openProductModal.apply(this, arguments);
}

function _openProductModal() {
  _openProductModal = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(productHandle) {
    var productModal, modalContent, modalHandle, url, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            productModal = window.quickshopModal;

            if (productModal) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            modalContent = document.querySelector('[data-quick-shop]');
            modalHandle = modalContent.getAttribute('data-product-handle');

            if (!(modalHandle !== productHandle)) {
              _context.next = 24;
              break;
            }

            modalContent.setAttribute('data-product-handle', productHandle);
            modalContent.innerHTML = '';
            url = "/products/".concat(productHandle, "?view=modal");
            _context.prev = 9;
            _context.next = 12;
            return fetch(url);

          case 12:
            response = _context.sent;

            if (!(response.ok === false)) {
              _context.next = 15;
              break;
            }

            throw new Error('Product modal fetch response was not OK');

          case 15:
            _context.next = 17;
            return response.text();

          case 17:
            modalContent.innerHTML = _context.sent;
            initProductModalContent();
            _context.next = 24;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](9);
            window.console.error(_context.t0);

          case 24:
            productModal.showModal();

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 21]]);
  }));
  return _openProductModal.apply(this, arguments);
}

/***/ }),

/***/ 236:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initProductModal),
/* harmony export */   "openProductModal": () => (/* binding */ openProductModal),
/* harmony export */   "createSizeModalUI": () => (/* binding */ createSizeModalUI)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(188);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(147);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(148);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(166);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(201);
/* harmony import */ var core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_is_array_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(168);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(169);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(170);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(115);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(91);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(174);
/* harmony import */ var _modal_dialog__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(165);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }






















function initProductModal() {
  var sizesModalElement = document.querySelector('#modal--product-sizes');
  var sizesModalTrigger = document.querySelectorAll('[data-open-product-sizes]');

  if (sizesModalElement && sizesModalTrigger.length > 0) {
    var sizesModal = new _modal_dialog__WEBPACK_IMPORTED_MODULE_20__.default(sizesModalElement, {
      triggerEl: sizesModalTrigger,
      modalId: 'product-sizes'
    });
    window.sizesModal = sizesModal;
  }
}

function initProductModalContent() {
  var productModal = window.sizesModal;

  if (!productModal) {
    return;
  }

  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_19__.load)('product-sizes-modal');
}

function openProductModal(productHandle, sizesElement) {
  var productModal = window.sizesModal;

  if (!productModal || !sizesElement) {
    return;
  }

  var sizesContent = sizesElement.cloneNode(true);
  var modalContent = document.querySelector('[data-product-sizes]');
  var modalHandle = modalContent.getAttribute('data-product-handle');

  if (modalHandle !== productHandle) {
    modalContent.setAttribute('data-product-handle', productHandle);
    modalContent.innerHTML = '';
    modalContent.insertAdjacentElement('beforeend', sizesContent);
    handleVariantSelect(sizesContent, productModal);
    initProductModalContent();
  }

  productModal.showModal();
}

function handleVariantSelect(parentElement, modalElement) {
  var _window, _window$theme, _window$theme$strings, _window2, _window2$theme, _window2$theme$string, _window3, _window3$theme, _window3$theme$string;

  var selectedVariantId = null; // const variantSelector = parentElement.querySelector('[data-product-select]');

  var variantButtons = parentElement.querySelectorAll('.product-card__variant');

  var isVariantSelected = _toConsumableArray(variantButtons).some(function (el) {
    return el.classList.contains('is-selected');
  });

  var addToCartButton = parentElement.querySelector('.product-card__add');
  var addLabel = ((_window = window) === null || _window === void 0 ? void 0 : (_window$theme = _window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$strings = _window$theme.strings) === null || _window$theme$strings === void 0 ? void 0 : _window$theme$strings.addToCart) || 'Add to cart';
  var addedLabel = ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$theme = _window2.theme) === null || _window2$theme === void 0 ? void 0 : (_window2$theme$string = _window2$theme.strings) === null || _window2$theme$string === void 0 ? void 0 : _window2$theme$string.addedMessage) || 'Added';
  var selectSizeLabel = ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$theme = _window3.theme) === null || _window3$theme === void 0 ? void 0 : (_window3$theme$string = _window3$theme.strings) === null || _window3$theme$string === void 0 ? void 0 : _window3$theme$string.selectSize) || 'Pick a size';
  var buttonWrapper = parentElement.querySelector('.product-card__actions');
  selectedVariantId = buttonWrapper.dataset.selectedVariantId;
  var comparePrice = Number(buttonWrapper.dataset.comparePrice);
  var productTagsDiv = evt.target.querySelector('button[data-product-tags]');
  var productTags = productTagsDiv ? productTagsDiv.getAttribute('data-product-tags') : null;

  if (!isVariantSelected) {
    addToCartButton.innerHTML = selectSizeLabel;
    addToCartButton.disabled = true;
  }

  parentElement.addEventListener('click', function (evt) {
    evt.preventDefault();
    var target = evt.target;
    var properties = {};

    if (target.matches('.product-card__variant')) {
      evt.preventDefault();
      selectedVariantId = Number(evt.target.dataset.variantId);
      comparePrice = Number(evt.target.dataset.variantComparePrice);
      addToCartButton.removeAttribute('disabled');
      addToCartButton.innerHTML = addLabel;
      buttonWrapper.dataset.selectedVariantId = selectedVariantId;
      buttonWrapper.dataset.comparePrice = comparePrice;
      variantButtons.forEach(function (button) {
        button.classList.remove('is-selected');
      });
      target.classList.add('is-selected');
    }

    if (target.matches('.product-card__add')) {
      evt.preventDefault();
      Object.assign(properties, {
        _compare_price: comparePrice
      });

      if (productTags && productTags.includes('DONOTSHIP')) {
        properties['_do_not_ship'] = 'DONOTSHIP';
      }

      var item = {
        id: selectedVariantId,
        quantity: 1,
        properties: properties
      };
      window.sideCart.handleAddToCartEvent(item, true).then(function () {
        return modalElement.closeModal();
      })["catch"](function (err) {
        return window.console.error(err);
      });
      target.innerHTML = addedLabel;
      setTimeout(function () {
        target.innerHTML = addLabel;
      }, 2000);
    }
  });
}

function createSizeModalUI(modalId) {
  var modal = document.querySelector(modalId);

  if (!modal) {
    document.body.insertAdjacentHTML('beforeend', "<div class=\"modal modal--product-sizes\" id=\"modal--product-sizes\" role=\"dialog\" hidden>\n        <div class=\"modal__dialog\">\n          <div class=\"modal__header\">\n            <h5>Select Size</h5>\n            <button type=\"button\" class=\"btn--icon modal__close-button\" data-modal-close=\"modal--product-sizes\"><svg aria-label=\"Cross icon\" class=\"icon icon-cross\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\" vector-effect=\"non-scaling-stroke\" d=\"M17 7L7 17M7 7l10 10\"/></svg></button>\n          </div>\n          <div data-product-sizes></div>\n        </div>\n      </div>");
    initProductModal(modal);
  }
}

/***/ }),

/***/ 237:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ initWishlistModal),
/* harmony export */   "openWishlistModal": () => (/* binding */ openWishlistModal),
/* harmony export */   "createWishlistModalUI": () => (/* binding */ createWishlistModalUI)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(188);
/* harmony import */ var core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(166);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(174);
/* harmony import */ var _wishlist__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(235);
/* harmony import */ var _modal_dialog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(165);
/* harmony import */ var _custom_select_hybrid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(238);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }











function initWishlistModal() {
  var wishlistModalElement = document.querySelector('#modal--wishlist');
  var wishlistModalTriggers = document.querySelectorAll('[data-trigger-wishlist-modal]');

  if (wishlistModalElement && wishlistModalTriggers.length > 0) {
    var wishlistModal = new _modal_dialog__WEBPACK_IMPORTED_MODULE_9__.default(wishlistModalElement, {
      triggerEl: wishlistModalTriggers,
      modalId: 'wishlist'
    });
    window.wishlistModal = wishlistModal;
  }
}

function initWishlistModalContent() {
  var wishlistModal = window.wishlistModal;

  if (!wishlistModal) {
    return;
  }

  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_7__.load)('wishlist-sizes-modal');
}

function updateWishlistButtonState(wishlistButton, wishlistedItems, selectedItem) {
  if (wishlistedItems.some(function (_ref) {
    var epi = _ref.epi;
    return Number(epi) === Number(selectedItem);
  })) {
    var _window$theme, _window$theme$strings;

    wishlistButton.classList.add('is-wishlisted');
    wishlistButton.innerHTML = ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$strings = _window$theme.strings) === null || _window$theme$strings === void 0 ? void 0 : _window$theme$strings.removeFromWishlist) || 'Remove from wishlist';
  } else {
    var _window$theme2, _window$theme2$string;

    wishlistButton.classList.remove('is-wishlisted');
    wishlistButton.innerHTML = ((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : (_window$theme2$string = _window$theme2.strings) === null || _window$theme2$string === void 0 ? void 0 : _window$theme2$string.addToWishlist) || 'Add to wishlist';
  }
}
/**
 * Handles opening wishlist modal w. Size Variant selectors for user to pick which variant they intend to wishlist
 * @param {String} productHandle Handle of parent product
 * @param {NodeList} sizesElement Element with variant sizes select box
 * @param {String} productTitle Title of product
 * @param {String} productColour Product Colour name
 * @param {Object} wishlistProduct Wishlist formatted object containing at least `epi, empi, du and pr` props (https://api-docs.swym.it/v3/index.html#add-to-wishlist-addtowishlist)
 */


function openWishlistModal(productHandle, sizesElement, sizesElementCustom, productTitle, productColour, wishlistProduct) {
  var productModal = window.wishlistModal;
  var wishlistedProductsObj = JSON.parse(localStorage.getItem('swym-products'));
  var wishlistedItems = wishlistedProductsObj.all;

  if (!productModal || !sizesElement) {
    return;
  }

  var sizesContent = sizesElement.cloneNode(true);
  var sizesContentCustom = sizesElementCustom.cloneNode(true);
  var modalContent = document.querySelector('[data-wishlist-sizes]');
  var modalHandle = modalContent.getAttribute('data-product-handle');

  if (modalHandle !== productHandle) {
    modalContent.setAttribute('data-product-handle', productHandle);
    modalContent.innerHTML = '';
    modalContent.insertAdjacentElement('beforeend', sizesContent);
    modalContent.insertAdjacentElement('beforeend', sizesContentCustom);
    sizesContent.classList.add('selectNative');
    sizesContent.classList.add('js-selectNative');
    handleVariantSelect(sizesContent, productModal, productTitle, productColour, wishlistProduct, wishlistedItems);
    initWishlistModalContent();
    var customSelectHybridsSelectors = document.querySelectorAll('.custom-select-hybrid-wishlist');
    (0,_custom_select_hybrid__WEBPACK_IMPORTED_MODULE_10__.default)(customSelectHybridsSelectors);
  }

  productModal.showModal();
}

function handleVariantSelect(parentEl, modalElement, productTitle, productColour, wishlistProduct, wishlistedItems) {
  var _parentEl$parentEl$se;

  var selectedVariantId = ((_parentEl$parentEl$se = parentEl[parentEl.selectedIndex]) === null || _parentEl$parentEl$se === void 0 ? void 0 : _parentEl$parentEl$se.value) || null;
  var modalDialogEl = parentEl.closest('.modal__content');
  var colourElem = modalDialogEl.querySelector('.modal__product-colour');
  var titleElem = modalDialogEl.querySelector('.modal__product-title');
  var existingAddToWishListBtn = modalDialogEl.querySelector('[data-add-item-to-wishlist]');
  var newAddToWishlistBtn = existingAddToWishListBtn.cloneNode(true);
  modalDialogEl.replaceChild(newAddToWishlistBtn, existingAddToWishListBtn);
  var addToWishListBtn = modalDialogEl.querySelector('[data-add-item-to-wishlist]');
  parentEl.classList.remove('no-js');

  if (!selectedVariantId) {
    addToWishListBtn.disabled = true;
  }

  wishlistProduct.epi = selectedVariantId;
  updateWishlistButtonState(addToWishListBtn, wishlistedItems, wishlistProduct.epi);

  if (productTitle) {
    titleElem.innerHTML = productTitle;
  }

  if (productColour) {
    colourElem.innerHTML = "Colour: ".concat(productColour);
  } else {
    colourElem.innerHTML = '';
  }

  parentEl.addEventListener('change', function () {
    var _parentEl$parentEl$se2;

    selectedVariantId = (_parentEl$parentEl$se2 = parentEl[parentEl.selectedIndex]) === null || _parentEl$parentEl$se2 === void 0 ? void 0 : _parentEl$parentEl$se2.value;
    wishlistProduct.epi = selectedVariantId;
    updateWishlistButtonState(addToWishListBtn, wishlistedItems, wishlistProduct.epi);
  });
  addToWishListBtn.addEventListener('click', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _window$theme3, _window$theme3$string, response, _window$theme5, _window$theme5$string, _response;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!addToWishListBtn.classList.contains('is-wishlisted')) {
              _context.next = 11;
              break;
            }

            _context.next = 3;
            return (0,_wishlist__WEBPACK_IMPORTED_MODULE_8__.removeFromWishList)(wishlistProduct);

          case 3:
            response = _context.sent;

            if (!(response.ok === false)) {
              _context.next = 6;
              break;
            }

            throw new Error('Could not remove item from wishlist');

          case 6:
            addToWishListBtn.classList.remove('is-wishlisted');
            addToWishListBtn.innerHTML = ((_window$theme3 = window.theme) === null || _window$theme3 === void 0 ? void 0 : (_window$theme3$string = _window$theme3.strings) === null || _window$theme3$string === void 0 ? void 0 : _window$theme3$string.removedFromWishlist) || 'Removed from wishlist';
            setTimeout(function () {
              var _window$theme4, _window$theme4$string;

              modalElement.closeModal();
              addToWishListBtn.innerHTML = ((_window$theme4 = window.theme) === null || _window$theme4 === void 0 ? void 0 : (_window$theme4$string = _window$theme4.strings) === null || _window$theme4$string === void 0 ? void 0 : _window$theme4$string.addToWishlistaddToWishlist) || 'Add to wishlist';
            }, 1500);
            _context.next = 19;
            break;

          case 11:
            _context.next = 13;
            return (0,_wishlist__WEBPACK_IMPORTED_MODULE_8__.addToWishList)(wishlistProduct);

          case 13:
            _response = _context.sent;

            if (!(_response.ok === false)) {
              _context.next = 16;
              break;
            }

            throw new Error('Could not add item to wishlist');

          case 16:
            addToWishListBtn.classList.add('is-wishlisted');
            addToWishListBtn.innerHTML = ((_window$theme5 = window.theme) === null || _window$theme5 === void 0 ? void 0 : (_window$theme5$string = _window$theme5.strings) === null || _window$theme5$string === void 0 ? void 0 : _window$theme5$string.addedToWishlist) || 'Added to wishlist';
            setTimeout(function () {
              var _window$theme6, _window$theme6$string;

              modalElement.closeModal();
              addToWishListBtn.innerHTML = ((_window$theme6 = window.theme) === null || _window$theme6 === void 0 ? void 0 : (_window$theme6$string = _window$theme6.strings) === null || _window$theme6$string === void 0 ? void 0 : _window$theme6$string.removeFromWishlist) || 'Remove from wishlist';
            }, 1500);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
}

function createWishlistModalUI(modalId) {
  var modal = document.querySelector(modalId);

  if (!modal) {
    var _window$theme7, _window$theme7$string, _window$theme8, _window$theme8$string;

    document.body.insertAdjacentHTML('beforeend', "<div class=\"modal modal--wishlist\" id=\"modal--wishlist\" role=\"dialog\" hidden>\n        <div class=\"modal__dialog\">\n          <div class=\"modal__header\">\n            <h5>".concat(((_window$theme7 = window.theme) === null || _window$theme7 === void 0 ? void 0 : (_window$theme7$string = _window$theme7.strings) === null || _window$theme7$string === void 0 ? void 0 : _window$theme7$string.addToWishlist) || 'Add to wishlist', "</h5>\n            <button type=\"button\" class=\"btn--icon modal__close-button\" data-modal-close=\"modal--wishlist\"><svg aria-label=\"Cross icon\" class=\"icon icon-cross\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"1.5\" vector-effect=\"non-scaling-stroke\" d=\"M17 7L7 17M7 7l10 10\"/></svg></button>\n          </div>\n          <div class=\"modal__content\">\n            <p class=\"modal__meta\">\n              <span class=\"modal__product-title\"></span><br>\n              <span class=\"modal__product-colour\"></span>\n            </p>\n            <div class=\"custom-select-hybrid-wishlist form__group\">\n              <div class=\"selectWrapper\" data-wishlist-sizes></div>\n            </div>\n            <button data-add-item-to-wishlist class=\"btn btn--block\">").concat(((_window$theme8 = window.theme) === null || _window$theme8 === void 0 ? void 0 : (_window$theme8$string = _window$theme8.strings) === null || _window$theme8$string === void 0 ? void 0 : _window$theme8$string.addToWishlist) || 'Add to wishlist', "</button>\n          </div>\n        </div>\n      </div>"));
    initWishlistModal(modal);
  }
}

/***/ }),

/***/ 276:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VAN11Y_TAB_ID_ATTRIBUTE": () => (/* binding */ VAN11Y_TAB_ID_ATTRIBUTE)
/* harmony export */ });
// just documenting this magic string as being from van11y-accessible-tab-panel-aria
var VAN11Y_TAB_ID_ATTRIBUTE = 'aria-controls';


/***/ }),

/***/ 280:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);

(0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('article-template', {// onLoad() {},
});

/***/ }),

/***/ 282:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('collection-icons', {
  onLoad: function onLoad() {
    var iconsSlider = this.container.querySelector('.collection__icons-row');

    if (iconsSlider) {
      var _iconsSlider$querySel;

      var isTabletUp = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.medium, "px)")).matches;
      var iconBlockCount = (_iconsSlider$querySel = iconsSlider.querySelectorAll('.collection__icons-row-item')) === null || _iconsSlider$querySel === void 0 ? void 0 : _iconsSlider$querySel.length;
      var isWrapAround = true;
      if (!iconBlockCount) return;

      if (iconBlockCount < 8) {
        iconsSlider.classList.add('collection__icons-row--sub-eight');
      }

      if (isTabletUp && iconBlockCount < 8) {
        isWrapAround = false;
      } // eslint-disable-next-line no-new


      new (flickity__WEBPACK_IMPORTED_MODULE_1___default())(iconsSlider, {
        // options
        draggable: '>1',
        prevNextButtons: true,
        pageDots: false,
        cellAlign: 'center',
        imagesLoaded: true,
        wrapAround: isWrapAround,
        freeScroll: false,
        watchCSS: true,
        contain: true,
        arrowShape: 'M70.6 94.39A4.91 4.91 0 0 1 67.11 93L24.16 50l43-42.95a4.93 4.93 0 0 1 7 7l-36 36 36 36a4.93 4.93 0 0 1-3.48 8.42Z'
      });
    }
  }
}));

/***/ }),

/***/ 283:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('featured-articles', {
  onLoad: function onLoad() {
    this.sliderId = "#articles__slider--".concat(this.id);
    var thisSlider = document.querySelector("#articles__slider--".concat(this.id)); // eslint-disable-next-line no-unused-vars

    var flickity = new (flickity__WEBPACK_IMPORTED_MODULE_1___default())(thisSlider, {
      // options
      contain: true,
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      watchCSS: true
    });
  }
}));

/***/ }),

/***/ 286:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony import */ var _components_product_cards_sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(275);
/* global van11yAccessibleTabPanelAria */


var SELECTORS = {
  featuredCollectionsSlider: '.js-featured-collections-slider',
  tabs: '.js-tabs'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('featured-collections', {
  onLoad: function onLoad() {
    var sliders = this.container.querySelectorAll(SELECTORS.featuredCollectionsSlider);
    (0,_components_product_cards_sliders__WEBPACK_IMPORTED_MODULE_1__.hydrateProductCardsSliders)(sliders);
    (0,_components_product_cards_sliders__WEBPACK_IMPORTED_MODULE_1__.resizeSliderOnTabChange)(this.container, SELECTORS.featuredCollectionsSlider); // Only run in the admin theme customizer

    if (Shopify.designMode) {
      // Reinitialise tabs after adding/removing blocks
      var tabs = this.container.querySelector(SELECTORS.tabs); // Only reinitialise if the tabs exist and tabs JS hasn't already run (it gives the tabs div an id)

      if (tabs && !tabs.id) {
        van11yAccessibleTabPanelAria(this.container);
      }
    }
  }
}));

/***/ }),

/***/ 288:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__);



var selectors = {
  sliderContainer: '[data-slider-container]'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('featured-images', {
  onLoad: function onLoad() {
    var container = this.container;
    var slider = container.querySelector(selectors.sliderContainer);
    if (!slider) return; // eslint-disable-next-line no-unused-vars

    var flickity = new (flickity__WEBPACK_IMPORTED_MODULE_1___default())(slider, {
      // options
      contain: true,
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      watchCSS: true
    });
  }
}));

/***/ }),

/***/ 287:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('featured-media', {
  onLoad: function onLoad() {
    this.sliderId = "#featured-media__slider--".concat(this.id);
    var thisSlider = document.querySelector("#featured-media__slider--".concat(this.id)); // eslint-disable-next-line no-unused-vars

    var flickity = new (flickity__WEBPACK_IMPORTED_MODULE_1___default())(thisSlider, {
      // options
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      watchCSS: true
    });
  }
}));

/***/ }),

/***/ 285:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(174);
/* harmony import */ var _components_product_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(247);




(0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__.register)('featured-product-tiles', {
  onLoad: function onLoad() {
    var _this = this;

    var productsInImages = this.container.querySelectorAll('.featured-product-tile__button-wrap');
    productsInImages.forEach(function (product) {
      return _this.productInit(product);
    });
  },
  productInit: function productInit(container) {
    var quickShopButton = container.querySelector('[data-open-quick-shop]');

    if (quickShopButton) {
      var productHandle = quickShopButton.dataset.openQuickShop;
      quickShopButton.addEventListener('click', function () {
        (0,_components_product_modal__WEBPACK_IMPORTED_MODULE_3__.openProductModal)(productHandle);
      });
    }
  }
});

/***/ }),

/***/ 284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(184);






/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_2__.register)('featured-products', {
  onLoad: function onLoad() {
    this.sliderId = "#featured-products__slider--".concat(this.id);
    var thisSlider = document.querySelector("#featured-products__slider--".concat(this.id));
    var productCards = thisSlider.querySelectorAll('.product-card');

    if (productCards.length > 0) {
      productCards.forEach(function (product) {
        return (0,_components_product_card__WEBPACK_IMPORTED_MODULE_5__.default)(product);
      });
    } // eslint-disable-next-line no-unused-vars


    var flickity = new (flickity__WEBPACK_IMPORTED_MODULE_3___default())(thisSlider, {
      // options
      freeScroll: false,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      setGallerySize: true,
      cellAlign: 'left',
      watchCSS: true
    });
  }
}));

/***/ }),

/***/ 281:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_5__);






/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__.register)('hero-slider', {
  onLoad: function onLoad() {
    this.sliderId = "#hero-slider--".concat(this.id);
    var thisSlider = document.querySelector("#hero-slider--".concat(this.id));
    this.userSettings = {
      prevNextButtons: JSON.parse(this.container.dataset.prevNextBtns),
      autoplaySpeed: JSON.parse(this.container.dataset.autoplaySpeed),
      pageDots: JSON.parse(this.container.dataset.pageDots),
      wrapAround: JSON.parse(this.container.dataset.wrapAround)
    };
    this.slider = new (flickity__WEBPACK_IMPORTED_MODULE_4___default())(thisSlider, {
      draggable: '>1',
      prevNextButtons: this.userSettings.prevNextButtons,
      autoPlay: this.userSettings.autoplaySpeed,
      pageDots: this.userSettings.pageDots,
      adaptiveHeight: false,
      watchCSS: true,
      wrapAround: this.userSettings.wrapAround,
      groupCells: true,
      on: {
        ready: function ready() {
          thisSlider.classList.add('is-visible');
        }
      }
    });
  },
  onBlockSelect: function onBlockSelect(event) {
    // Only run in the admin theme customizer
    if (!Shopify.designMode) {
      return;
    } // Turn off autoplay when slide selected


    if (this.userSettings.autoplaySpeed !== 0) {
      this.slider.pausePlayer();
    } // Scroll to selected slide


    var index = Array.from(event.target.parentElement.children).indexOf(event.target);
    this.slider.select(index);
  },
  onDeselect: function onDeselect() {
    // Only run in the admin theme customizer
    if (!Shopify.designMode) {
      return;
    } // Turn back on autoplay when slider deselected


    if (this.userSettings.autoplaySpeed !== 0) {
      this.slider.unpausePlayer();
    }
  }
}));

/***/ }),

/***/ 274:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony import */ var _components_product_cards_sliders__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(275);
/* harmony import */ var _utils_recommendations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(277);




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




var SELECTORS = {
  recommendedResponseWrapper: '.js-product-recommendations__wrapper',
  recommendationsSlider: '.js-product-recommendations__slider',
  recommendationsGrid: '.js-product-recommendations__grid'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_3__.register)('product-recommendations', {
  onLoad: function onLoad() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var container, limit, productId, sectionId, result, sliderContainer, sliderGrid;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              container = _this.container;
              limit = container.dataset.limit;
              productId = container.dataset.productId;
              sectionId = container.dataset.sectionId;
              _context.next = 6;
              return (0,_utils_recommendations__WEBPACK_IMPORTED_MODULE_5__.placeRecommendationsIntoDOM)({
                productId: productId,
                sectionId: sectionId,
                limit: limit,
                responseWrapperSelector: SELECTORS.recommendedResponseWrapper,
                targetElement: container
              });

            case 6:
              result = _context.sent;

              if (result) {
                sliderContainer = container.querySelector(SELECTORS.recommendationsSlider);
                sliderGrid = container.querySelector(SELECTORS.recommendationsGrid);

                if (sliderContainer) {
                  (0,_components_product_cards_sliders__WEBPACK_IMPORTED_MODULE_4__.hydrateProductCardsSliders)([sliderContainer]);
                } else if (sliderGrid) {
                  (0,_components_product_cards_sliders__WEBPACK_IMPORTED_MODULE_4__.hydrateProductsWithinElement)(sliderGrid);
                }
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
}));

/***/ }),

/***/ 278:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(194);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(143);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(137);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(139);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(144);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(145);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(146);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(174);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(202);
/* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(flickity__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(220);
/* harmony import */ var flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(flickity_imagesloaded__WEBPACK_IMPORTED_MODULE_12__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var SELECTORS = {
  recommendationsSliders: '.product-cards-carousel__slider',
  productCards: '.product-card'
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_10__.register)('ss-recommendations', {
  onLoad: function onLoad() {
    var _this = this;

    /**
     * hydrateProductCardsSliders adds the slider behaviour to the raw slider HTML
     * and the raw products within that.
     *
     * @param {NodeList|array} sliders                - Slider nodes to hydrate
     * @param {object}         options                - options object
     */
    var hydrateProductCardsSliders = function hydrateProductCardsSliders(sliders, options) {
      if (sliders.length === 0) {
        return;
      }

      var isDesktop = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.large, "px)")).matches;
      sliders.forEach(function (slider) {
        var _slider$querySelector;

        var cardCount = (_slider$querySelector = slider.querySelectorAll(SELECTORS.productCards)) === null || _slider$querySelector === void 0 ? void 0 : _slider$querySelector.length;
        if (!cardCount) return;

        if (isDesktop && cardCount < 5) {
          slider.classList.add('product-cards-carousel__slider--sub-five', 'searchspring-slider');
        }

        hydrateMainSlider(slider, _objectSpread(_objectSpread({}, options), {}, {
          isDesktop: isDesktop
        }));
      });
    };
    /**
     * hydrateMainSlider adds the slider behaviour to the raw slider HTML
     * and the raw products within that.
     *
     * @param {Element}  slider                 - Slider to hydrate
     * @param {object}   options                - options object
     * @param {boolean}  options.productCount   - how many products are contained in this slider?
     */


    var hydrateMainSlider = function hydrateMainSlider(slider, _ref) {
      var isDesktop = _ref.isDesktop;
      return new (flickity__WEBPACK_IMPORTED_MODULE_11___default())(slider, {
        // options
        prevNextButtons: true,
        pageDots: isDesktop,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: isDesktop ? 'center' : 'left',
        groupCells: isDesktop ? 3 : false,
        watchCSS: true,
        wrapAround: isDesktop,
        contain: !isDesktop
      });
    };

    window.addEventListener('searchspring.domReady', function () {
      var tabSliders = _this.container.querySelectorAll(SELECTORS.recommendationsSliders);

      tabSliders.forEach(function (sliderContainer) {
        hydrateProductCardsSliders([sliderContainer]);
      });
    }); // Adds a desktop query resize event to reinitialise the sliders because the config is different between mobile and desktop

    var desktopQuery = window.matchMedia("(min-width: ".concat(window.theme.breakpoints.large, "px)"));

    var desktopQueryCallback = function desktopQueryCallback() {
      var tabSliders = _this.container.querySelectorAll(SELECTORS.recommendationsSliders);

      tabSliders.forEach(function (sliderContainer) {
        hydrateProductCardsSliders([sliderContainer]);
      });
    }; // Check for `addEventListener` is required to support iOS and Safari <14.


    if (typeof (desktopQuery === null || desktopQuery === void 0 ? void 0 : desktopQuery.addEventListener) === 'function') {
      desktopQuery.addEventListener('change', desktopQueryCallback.bind(this));
    } else {
      desktopQuery.addListener(desktopQueryCallback.bind(this));
    }
  }
}));

/***/ }),

/***/ 279:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(174);
/* harmony import */ var _sections_article__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(280);
/* harmony import */ var _sections_hero_slider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(281);
/* harmony import */ var _sections_collection_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(282);
/* harmony import */ var _sections_featured_articles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(283);
/* harmony import */ var _sections_featured_products__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(284);
/* harmony import */ var _sections_featured_product_tiles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(285);
/* harmony import */ var _sections_featured_collections__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(286);
/* harmony import */ var _sections_featured_media__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(287);
/* harmony import */ var _sections_featured_images__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(288);
/* harmony import */ var _sections_product_recommendations__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(274);
/* harmony import */ var _sections_ss_recommendations__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(278);












document.addEventListener('DOMContentLoaded', function () {
  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.load)('*');
});

/***/ }),

/***/ 277:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "placeRecommendationsIntoDOM": () => (/* binding */ placeRecommendationsIntoDOM)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);







function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * @function placeRecommendationsIntoDOM - the recommendations api is called with the
 * specified section in relation to the specified product which returns a markup.
 * The selected node as per the provided selector within that response is then injected into the DOM
 * as children of the provided targetElement.
 *
 * @param {string}  productId               - the product for which recommendations are sought
 * @param {number}  limit                   - max number of recommendations to seek
 * @param {string}  sectionId               - the section that is being used to render the recommendations response
 * @param {string}  responseWrapperSelector - this selector should select the node within the section response to be inserted into the DOM.
 * @param {Element} targetElement           - the element whose children should become the recommendations response.
 *
 * @returns {boolean} true if succeeded, false otherwise.
 */
var placeRecommendationsIntoDOM = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var productId, limit, sectionId, responseWrapperSelector, targetElement, rootUrl, requestUrl, response, data, fragment;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            productId = _ref.productId, limit = _ref.limit, sectionId = _ref.sectionId, responseWrapperSelector = _ref.responseWrapperSelector, targetElement = _ref.targetElement;

            if (!(productId === '' || productId === null || productId === undefined || !targetElement)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", false);

          case 3:
            rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
            requestUrl = "".concat(rootUrl, "/recommendations/products?section_id=").concat(sectionId, "&limit=").concat(limit, "&product_id=").concat(productId);
            _context.prev = 5;
            _context.next = 8;
            return fetch(requestUrl);

          case 8:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", false);

          case 11:
            _context.next = 13;
            return response.text();

          case 13:
            data = _context.sent;
            fragment = document.createRange().createContextualFragment(data).querySelector(responseWrapperSelector);

            if (fragment) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", false);

          case 17:
            if ('replaceChildren' in HTMLElement.prototype) {
              targetElement.replaceChildren(fragment);
            } else {
              targetElement.childNodes.forEach(function (node) {
                return node.remove();
              });
              targetElement.appendChild(fragment);
            }

            return _context.abrupt("return", true);

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](5);
            window.console.error(_context.t0);
            return _context.abrupt("return", false);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 21]]);
  }));

  return function placeRecommendationsIntoDOM(_x) {
    return _ref2.apply(this, arguments);
  };
}();



/***/ }),

/***/ 235:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addToWishList": () => (/* binding */ addToWishList),
/* harmony export */   "removeFromWishList": () => (/* binding */ removeFromWishList),
/* harmony export */   "fetchWishlistItems": () => (/* binding */ fetchWishlistItems),
/* harmony export */   "initWishlist": () => (/* binding */ initWishlist),
/* harmony export */   "WISHLIST_FETCHED_EVT_NAME": () => (/* binding */ WISHLIST_FETCHED_EVT_NAME)
/* harmony export */ });
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(116);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(100);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_6__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }







var WISHLIST_FETCHED_EVT_NAME = 'wishlistItemsFetched';
/**
 * @function triggerWishlistRequest - Adds a function to the SwymCallbacks queue to be exectued once swym is loaded on the page.
 */

var triggerWishlistRequest = function triggerWishlistRequest(fn) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(fn);
};
/**
 * @function addToWishList - Adds a setting to the wishlist.
 *
 * @returns {Promise}
 */


var addToWishList = function addToWishList(product) {
  return new Promise(function (resolve, reject) {
    triggerWishlistRequest(function () {
      return window._swat.addToWishList(product, function (response) {
        resolve(response);

        if (window.wishlistItems) {
          window.wishlistItems.push(response);
          document.dispatchEvent(new Event(WISHLIST_FETCHED_EVT_NAME));
        }
      }, function (error) {
        reject(error);
      });
    });
  });
};
/**
 * @function removeFromWishList - Removes a setting from the wishlist.
 *
 * @returns {Promise}
 */


var removeFromWishList = function removeFromWishList(product) {
  return new Promise(function (resolve, reject) {
    triggerWishlistRequest(function () {
      return window._swat.removeFromWishList(product, function (response) {
        resolve(response);

        if (window.wishlistItems) {
          var updatedWishlistItems = window.wishlistItems.filter(function (item) {
            return Number(item.epi) !== Number(response.epi);
          });
          window.wishlistItems = updatedWishlistItems;
          document.dispatchEvent(new Event(WISHLIST_FETCHED_EVT_NAME));
        }
      }, function (error) {
        reject(error);
      });
    });
  });
};
/**
 * @function fetchWishlistItems - Fetches all setting wishlist items
 *
 * @returns {Promise<wishlistItem[]>}
 */


var fetchWishlistItems = function fetchWishlistItems() {
  return new Promise(function (resolve) {
    return triggerWishlistRequest(function () {
      return window._swat.fetch(resolve);
    });
  });
};
/**
 * @function initWishlist - fetches wishlist items, assigns them to
 * window.wishlistItems, and dispatches an event to notify completion.
 */


var initWishlist = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var wishlistItems;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setSiteHeaderWishlistIconsStatus();
            _context.next = 3;
            return fetchWishlistItems();

          case 3:
            wishlistItems = _context.sent;
            window.wishlistItems = wishlistItems;
            document.dispatchEvent(new Event(WISHLIST_FETCHED_EVT_NAME));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initWishlist() {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @function setSiteHeaderWishlistIconsStatus - fills or hollows the page header
 * wishlist link icon depending on whether wishlist items were resolved (see
 * initWishlist above).
 */


var setSiteHeaderWishlistIconsStatus = function setSiteHeaderWishlistIconsStatus() {
  document.addEventListener(WISHLIST_FETCHED_EVT_NAME, function () {
    var _window$wishlistItems;

    var wishlistLinks = document.querySelectorAll('[data-wishlist-link]');

    if (wishlistLinks && ((_window$wishlistItems = window.wishlistItems) === null || _window$wishlistItems === void 0 ? void 0 : _window$wishlistItems.length) > 0) {
      wishlistLinks.forEach(function (link) {
        return link.classList.add('icon-animate');
      });
    } else {
      wishlistLinks.forEach(function (link) {
        return link.classList.remove('icon-animate');
      });
    }
  });
};



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			10: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) var result = runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkseafolly_theme"] = self["webpackChunkseafolly_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [28], () => (__webpack_require__(279)))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;